import { Children } from 'types/base.types';

type WalledGardenProps = {
  condition?: boolean | string | number | UndefinedOrNull;
  children: Children;
  type?: string;
};

/**
 * This is sightly different than "Maybe", since its ruled by the "walledGarden" attribute
 * from a partners. If the partners has walledGarden set to true, then we do not show the children
 *
 * Also, since this is a partners specific component, we do not need to pass in a condition, but can
 * always derive it from the partners object. We do allow an escape hatch with the condition prop.
 *
 * But reminder: This is a "walled component", don't misuse the intent.
 *
 * @param {WalledGardenProps} props
 * @returns {React.ReactElement}
 * @constructor
 */
const WalledGarden = (props: WalledGardenProps): React.ReactElement | null => {
  const { condition = true, children } = props || {};

  /*
     We can derive a walled garden by three means.
     1. A cookie.
     2. A partners object with walledGarden set to true.
        i. A walledGarden does NOT signify a partners, but rather an attribute of a partners.
        ii. a non-partners CAN have a walledGarden set to true. ie.. direct booking (they also have a cookie).
    3. a custom passed condition (same as with Maybe Component)
 */

  /* Passed Condition */
  if (condition) {
    return <>{children}</>;
  }

  /* Passed Partner Walled */
  // return <>{Boolean(condition) && children}</>;

  /* Passed Cookie Walled */
  // return <>{Boolean(condition) && children}</>;
  return null;
};

export default WalledGarden;
